export enum WindowMessageType {
  SelectedProductFromAEM = 'selectedProductFromAEM'
}
